import React from 'react';
import TableReport from "../../common/table/table";
import ClientUsersTable from "./clientUsersTable";
import MessageEmptyData from "../../common/messageEmptyData";

/**
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ClientUsersBody = (prop) => {
    const {filters, tableData} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={ClientUsersTable()}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'users'}
                withGlobalSearch={true}
                scrollable={false}
            />
        </div>
    );
}

export default ClientUsersBody;
